// extracted by mini-css-extract-plugin
export default {"municipalities":"AdminModal_municipalities__v-woE","comuni":"AdminModal_comuni__d+E5o"};